// Component: src/theme/snippets/drawer.liquid

document.addEventListener("DOMContentLoaded", () => {
  init();
});

const init = () => {
  const drawers = document.querySelectorAll(".generic-drawer");

  drawers.forEach((drawer) => {
    const id = drawer.id;
    const position = drawer.classList.contains("drawer-position-right") ? "right" : "left";
    const $main: HTMLDivElement | null = drawer.querySelector(".generic-drawer-main");
    const $overlay = drawer.querySelector(".generic-overlay");

    if (!id || !$main || !$overlay) return;

    document.addEventListener(
      `drawer:${id}:open`,
      () => {
        $overlay.classList.add("show");
        $overlay.classList.remove("pointer-events-none");
        if (position === "right") {
          $main.style.right = "0";
        } else {
          $main.style.left = "0";
        }
        document.body.classList.add("no-scroll");
      },
      { passive: true },
    );

    document.addEventListener(
      `drawer:${id}:close`,
      () => {
        $overlay.classList.remove("show");
        $overlay.classList.add("pointer-events-none");
        $main.style.right = '';
        $main.style.left = '';
        document.body.classList.remove("no-scroll");
      },
      { passive: true },
    );

    $overlay.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent(`drawer:${id}:close`));
    });
  });
};
